import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box } from "@mui/system";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { getProducto } from "../../../project/services/ArticuloService";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import BuscarProductoDialog from "./BuscarProductoDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const Producto = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    expandedAccordionProducto,
    setExpandedAccordionProducto,
    disabledAccordionProducto,
    initialProducto,
    producto,
    handleChangeProducto,
    setProducto,
    productosRows,
    setProductosRows,
    totalProductos,
    totalProductosContado,
    productosSelected,
    setProductosSelected,
    seleccionarProductos,
    showCheckBoxesProductosRows,
    showActionsProductosRows,
    showImportesContado,
    gaAction,
  } = useContext(GestionAtencionContext);

  let {
    productoId,
    productoCodigo,
    productoDescripcion,
    productoPrecioVenta,
    productoPrecioVentaOriginal,
    productoPorcentajeDescuento,
    productoPrecioVentaContado,
    productoCantidad,
    productoSubtotal,
    productoSubtotalContado,
  } = producto;

  const tableColumns = [
    {
      field: "productoCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "productoDescripcion",
      headerName: "Armazón",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "productoPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoPrecioVenta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "productoPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoPrecioVentaContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "productoCantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoCantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "productoSubtotal",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoSubtotal.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "productoSubtotalContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.productoSubtotalContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu === "view" && (
            <>
              <Tooltip title="ver">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => obtenerProducto(params.row)}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {gaAction.cu !== "view" && showActionsProductosRows && (
            <>
              <Tooltip title="quitar">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickActionProducto(params.row)}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickActionProducto = (parRow) => {
    if (parRow === null) {
      // si estoy agregando un producto

      let _producto = {
        id: uuidv4(),
        productoSelected: true,
        productoId: productoId,
        productoCodigo: productoCodigo,
        productoDescripcion: productoDescripcion,
        productoPrecioVenta: productoPrecioVenta,
        productoPrecioVentaOriginal: productoPrecioVentaOriginal,
        productoPorcentajeDescuento: productoPorcentajeDescuento,
        productoPrecioVentaContado: productoPrecioVentaContado,
        productoCantidad: productoCantidad,
        productoSubtotal: productoSubtotal,
        productoSubtotalContado: productoSubtotalContado,
      };
      setProductosRows([...productosRows, _producto]);
      setProductosSelected([...productosSelected, _producto.id]);

      setProducto(initialProducto);
      setExpandedAccordionProducto(false);
    } else {
      // si estoy eliminando un producto

      let _productosRows = productosRows.filter(
        (item) => item.id !== parRow.id
      );
      let _productosSelected = [];

      _productosRows.forEach((item, index) => {
        if (item.productoSelected) {
          _productosSelected.push(item.id);
        }
      });

      setProductosRows(_productosRows);
      setProductosSelected(_productosSelected);
    }
  };
  //
  // ################################################################################
  //
  const obtenerProducto = (parRow) => {
    let _producto = {
      // productoId: productosRows[parRow].productoId,
      productoCodigo: parRow.productoCodigo,
      productoDescripcion: parRow.productoDescripcion,
      productoPrecioVenta: parRow.productoPrecioVenta,
      // productoPrecioVentaOriginal: parRow.productoPrecioVentaOriginal,
      // productoPorcentajeDescuento: parRow.productoPorcentajeDescuento,
      productoPrecioVentaContado: parRow.productoPrecioVentaContado,
      productoCantidad: parRow.productoCantidad,
      productoSubtotal: parRow.productoSubtotal,
      productoSubtotalContado: parRow.productoSubtotalContado,
    };
    setProducto(_producto);
    setExpandedAccordionProducto(true);
  };
  //
  // ################################################################################
  //
  const handleBuscarProducto = () => {
    if (productoCodigo === "") {
      return;
    }
    buscarProducto(productoCodigo);
  };
  //
  // ################################################################################
  //
  const buscarProducto = async (parProductoCodigo) => {

    let _params = {
      codigo: parProductoCodigo,
      area: localStorage.getItem("id_area_ventas"),
    };

    setIsDoingSomething(true);
    const response = await getProducto(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _tipoArticulo = response.data.data[0].descripcion_tipo_articulo;

      let _id = "";
      switch (_tipoArticulo) {
        case "armazon":
        case "anteojo-sol":
          _id = response.data.data[0].id_ar_as_marca;
          break;
        case "lente-contacto":
          _id = response.data.data[0].id_lente_contacto_producto;
          break;
        case "solucion-limpieza":
          _id = response.data.data[0].id_sl_marca;
          break;
        default:
      }

      let _porcentajeDescuento = 0;
      let _precioVentaContado = response.data.data[0].precio_venta_lista;
      if (
        _tipoArticulo === "armazon" ||
        _tipoArticulo === "anteojo-sol" ||
        _tipoArticulo === "lente-contacto" ||
        _tipoArticulo === "solucion-limpieza"
      ) {
        let _params = {
          tipoArticulo: _tipoArticulo,
          id: _id,
        };

        const responseDescuento = await getPorcentajeDescuento(_params);
        if (responseDescuento.ok) {
          _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
        }
        _precioVentaContado =
          response.data.data[0].precio_venta_lista -
          (response.data.data[0].precio_venta_lista * _porcentajeDescuento) / 100;
      }

      let _producto = {
        productoId: response.data.data[0].id,
        productoCodigo: response.data.data[0].codigo,
        productoDescripcion: response.data.data[0].descripcion,
        productoPrecioVenta: response.data.data[0].precio_venta_lista,
        productoPrecioVentaOriginal: response.data.data[0].precio_venta_lista,
        productoPorcentajeDescuento: _porcentajeDescuento,
        productoPrecioVentaContado: _precioVentaContado,
        productoCantidad: 1,
        productoSubtotal: response.data.data[0].precio_venta_lista,
        productoSubtotalContado: _precioVentaContado,
      };
      setProducto(_producto);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
      setProducto(initialProducto);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);
    buscarProducto(articulo.codigo);
  };
  //
  // ################################################################################
  //
  const handleLimpiarProducto = () => {
    setProducto(initialProducto);
  };
  //
  // ################################################################################
  //
  const handleCancelar = () => {
    setProducto(initialProducto);
    setExpandedAccordionProducto(false);
  };
  //
  // ################################################################################
  //
  const handleBlur = (e) => {
    let _cantidad = e.target.value;
    _cantidad =
      _cantidad === "" || isNaN(_cantidad) || parseInt(+_cantidad) <= 0 ? 1 : parseInt(+_cantidad);
    let _subtotal = _cantidad * productoPrecioVenta;
    let _subtotalContado = _cantidad * productoPrecioVentaContado;
    setProducto({
      ...producto,
      productoCantidad: _cantidad,
      productoSubtotal: _subtotal,
      productoSubtotalContado: _subtotalContado,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box
        sx={{
          "& > :not(style)": {
            p: 2,
            m: 1,
          },
        }}
      >
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          <Accordion
            expanded={expandedAccordionProducto}
            disabled={disabledAccordionProducto}
            onChange={() => setExpandedAccordionProducto(!expandedAccordionProducto)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="anteojo"
            >
              <Typography>Producto</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  {/* codigo de producto */}
                  <TextField
                    sx={{ mb: 1 }}
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="codigo-producto"
                    label="Código del Producto"
                    variant="outlined"
                    size="small"
                    name="productoCodigo"
                    value={productoCodigo}
                    onChange={handleChangeProducto}
                    disabled={productoDescripcion !== ""}
                  />
                </Grid>

                {gaAction.cu !== "view" && (
                  <Grid item md={8}>
                    {/* boton buscar */}
                    <Button
                      sx={{ mr: 1, mb: 2 }}
                      variant="contained"
                      onClick={handleBuscarProducto}
                      startIcon={<SearchIcon />}
                      disabled={productoCodigo === "" || productoDescripcion !== ""}
                    >
                      Buscar
                    </Button>

                    {/* boton busqueda avanzada */}
                    <Button
                      sx={{ mr: 1, mb: 2 }}
                      variant="contained"
                      onClick={handleClickOpenBusquedaAvanzada}
                      startIcon={<SavedSearchIcon />}
                    >
                      Búsqueda Avanzada
                    </Button>

                    {/* boton limpiar */}
                    <Button
                      sx={{ mr: 1, mb: 2 }}
                      variant="outlined"
                      onClick={handleLimpiarProducto}
                      startIcon={<CleaningServicesIcon />}
                      disabled={productoCodigo === ""}
                    >
                      Limpiar
                    </Button>
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                  {/* descripcion del producto */}
                  <TextField
                    sx={{ width: "100%" }}
                    id="productoDescripcion"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="productoDescripcion"
                    value={productoDescripcion}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="productoPrecioVenta"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="productoPrecioVenta"
                    value={productoPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="productoPrecioVentaContado"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="productoPrecioVentaContado"
                    value={productoPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  <TextField
                    sx={{ width: "40%" }}
                    id="productoCantidad"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    name="productoCantidad"
                    value={productoCantidad}
                    onChange={handleChangeProducto}
                    onBlur={handleBlur}
                    disabled={productoCodigo === "" || gaAction.cu === "view"}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="productoSubtotal"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Sub Lista"
                    variant="outlined"
                    size="small"
                    name="productoSubtotal"
                    value={productoSubtotal.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="productoSubtotalContado"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Sub Contado"
                    variant="outlined"
                    size="small"
                    name="productoSubtotalContado"
                    value={productoSubtotalContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Box sx={{ p: 2 }}>
                {gaAction.cu !== "view" && (
                  <>
                    {/* boton agregar producto */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      disabled={productoCodigo === "" || productoDescripcion === ""}
                      onClick={() => handleClickActionProducto(null)}
                      startIcon={<Add />}
                    >
                      Agregar
                    </Button>
                  </>
                )}

                {/* boton de cancelar / cerrar */}

                <Button
                  sx={{ mr: 1 }}
                  variant="outlined"
                  onClick={handleCancelar}
                  startIcon={<CancelIcon />}
                >
                  {gaAction.cu !== "view" ? "Cancelar" : "Cerrar"}
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>

        <Paper elevation={3} sx={{ m: 1, p: 2 }}>

          <DataGrid
            rows={productosRows}
            columns={tableColumns}
            {...tableOptions}
            checkboxSelection={showCheckBoxesProductosRows}
            rowSelectionModel={showCheckBoxesProductosRows ? productosSelected : []}
            onRowSelectionModelChange={(newSelection) => {
              seleccionarProductos(newSelection);
            }}
          />

          <Grid container spacing={1}>
            <Grid item sm={showImportesContado ? 6 : 12}>
              <Typography
                component="div"
                align="right"
                sx={{
                  p: 1,
                  mt: 2,
                  backgroundColor: "SteelBlue",
                  borderRadius: "5px",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                }}
              >
                TOTAL DE LISTA: {formatMoney(totalProductos)}
              </Typography>
            </Grid>
            {showImportesContado ? (
              <>
                <Grid item sm={6}>
                  <Typography
                    component="div"
                    align="right"
                    sx={{
                      p: 1,
                      mt: 2,
                      backgroundColor: "SteelBlue",
                      borderRadius: "5px",
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                    }}
                  >
                    TOTAL DE CONTADO: {formatMoney(totalProductosContado)}
                  </Typography>
                </Grid>
              </>
            ) : null}
          </Grid>
        </Paper>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarProductoDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Producto;
